import { IntlFormatters } from "react-intl";

const formatNumber = (number: number) => ("0" + number.toString()).slice(-2);

export const getCompletionDate = (_date: number, formatDate: IntlFormatters["formatDate"]) => {
    const date = new Date(_date);
    return `${formatDate(date, { weekday: "short" })} ${formatNumber(date.getHours())}:${formatNumber(
        date.getMinutes()
    )}`;
};
